export const CONFIG_TYPE_PARAM_NAME = 'config_type';
export const API_KEY_NAME = 'API_KEY';
